import { Group, Stack } from '@mantine/core'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { useServicingFeed } from './use-servicing-feed'

/**
 * The Servicing page: ONE request builds every row server-side
 * (GET /api/servicing/events, ADR_LOS-030); the tabs filter it locally and
 * the row menus fetch what they edit when they open. The 21 list loads this
 * page used to make on arrival are gone.
 */
export function ServicingDrillPage() {
  useServicingFeed()

  // The page loads no list. The loan row menu loads the index rate options
  // it decides Rollover vs Conversion from when it opens, and hides the
  // term-dependent items until they land (loan-actions.tsx); the rollover,
  // conversion and merge forms read them through their own prerequisite
  // reads. My Work does the same.

  const tabs = {
    all: { route: `/assetservicing`, label: 'ALL' },
    scheduled: { route: `/assetservicing/scheduled`, label: 'SCHEDULED' },
    unscheduled: { route: `/assetservicing/unscheduled`, label: 'UNSCHEDULED' },
  }

  return (
    <Stack w="100%">
      <Group w="100%" position="apart" className="tabsGapsActivity">
        <Group position="right">
          <SegmentControlUpdated tabs={tabs} />
        </Group>
      </Group>
      <Outlet />
    </Stack>
  )
}
